<template>
  <div class="help-page">
    <h2 v-if="headingText" class="help-page__heading">{{ headingText }}</h2>

    <div class="help-page__content">
      <slot />
    </div>

    <HelpControls
      :previousPage="previousPage"
      :nextPage="nextPage"
      @navigate="(page) => $emit('navigate', page)"
    />
  </div>
</template>

<script>
import HelpControls from '@/views/Help/HelpControls.vue';

export default {
  name: 'HelpPage',
  props: {
    headingText: {
      type: String,
      default: '',
    },
    nextPage: {
      type: Object,
      default: () => {},
    },
    previousPage: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    HelpControls,
  },
};
</script>
<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';
@use 'styles/core/layout/grid-vars';
@use 'styles/core/typography/fonts';
@use 'styles/core/typography/type';

.help-page {
  color: colors.color(grey, tertiary);

  &__heading {
    @include type.text--h2;

    @include fonts.font-size(36);

    margin-bottom: grid-vars.space(3);
  }

  &__content {
    @include type.help-copy;
  }
}
</style>
